import { render, staticRenderFns } from "./NewUserClabe.vue?vue&type=template&id=7967ebfc&"
import script from "./NewUserClabe.vue?vue&type=script&lang=js&"
export * from "./NewUserClabe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports